<template>
    <div class="ReportsPane">
        <div class="container-fluid container-fill">
            <div class="row">
                <div class="col-md-4">
                    <h4>Data Access Reports</h4>
                    <ReportDownloader report-label="Communication Log Export"
                                      endpoint="Residential/Reports/ResidenceReports/ResidenceLogEntries"
                                      :parameter-schema="ParamsResidenceStartEnd"
                                      report-description="Exports Communication Log entries for the specified time period" />
                    
                </div>
                <div class="col-md-4">
                    <h4></h4>
                    
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faPlus } from '@fortawesome/free-solid-svg-icons';
    library.add(faPlus);
    import { faList } from '@fortawesome/free-solid-svg-icons';
    library.add(faList);
    import { faChild } from '@fortawesome/free-solid-svg-icons';
    library.add(faChild);
    //import components
    import ReportDownloader from '../../../Core/UI/ReportDownloader.vue';
    export default {
        props: ["ResidenceData"],
        data: function () {
            return {

                ParamsResidenceStartEnd: [
                    {
                        Label: "Residence:",
                        Name: "ResidenceID",
                        Type: "HiddenConstant",
                        DisplayValue: "",
                        Value: ""
                    },
                    {
                        Label: "Start Date:",
                        Name: "StartDate",
                        Type: "Date",
                        Required: true
                    },
                    {
                        Label: "End Date:",
                        Name: "EndDate",
                        Type: "Date",
                        Required: true
                    }
                ],
               
            };
        },
        methods: {

        },
        computed: {
        },
        components: {
            ReportDownloader
        },
        mounted() {
            this.ParamsResidenceStartEnd[0].Value = this.ResidenceData.Id
            this.ParamsResidenceStartEnd[0].DisplayValue = this.ResidenceData.Name;
        }
    }
</script>

<style scoped>
</style>